// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
    display: flex;
    align-items: center;
    justify-content: center;
}

.user-info {
    display: flex;
    align-items: center;
    gap: 12px;
}

.greeting {
    color: white;
    font-size: 14px;
}

.login-button,
.logout-button {
    background-color: #303030;
    color: #ededed;
    font-weight: 300;
    padding: 8px 20px;
    border-radius: 50px;
    border: none;
    outline: none;
    cursor: pointer;
    font-family: 'Lexend', sans-serif;
}

.login-button:hover,
.logout-button:hover {
    background-color: #ededed;
    color: #303030;
}
`, "",{"version":3,"sources":["webpack://./src/components/Login/login.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;;IAEI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,iCAAiC;AACrC;;AAEA;;IAEI,yBAAyB;IACzB,cAAc;AAClB","sourcesContent":[".login-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.user-info {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.greeting {\n    color: white;\n    font-size: 14px;\n}\n\n.login-button,\n.logout-button {\n    background-color: #303030;\n    color: #ededed;\n    font-weight: 300;\n    padding: 8px 20px;\n    border-radius: 50px;\n    border: none;\n    outline: none;\n    cursor: pointer;\n    font-family: 'Lexend', sans-serif;\n}\n\n.login-button:hover,\n.logout-button:hover {\n    background-color: #ededed;\n    color: #303030;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
